import { render } from "./MxButton.vue?vue&type=template&id=14147b9b&scoped=true"
import script from "./MxButton.vue?vue&type=script&lang=js"
export * from "./MxButton.vue?vue&type=script&lang=js"

import "./MxButton.vue?vue&type=style&index=0&id=14147b9b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14147b9b"]])

export default __exports__